import React from 'react';
import styled from 'styled-components';

export function VideoPlayer({
  src,
  width = '100%',
  height = '100%',
  css = {},
}) {
  return (
    <VideoPlayer.wrapper>
      <video
        src={src}
        width={width}
        height={height}
        controls
        autoPlay
        muted
        css
      />
    </VideoPlayer.wrapper>
  );
}

VideoPlayer.wrapper = styled.div`
  margin-top: 0.5rem;
`;
